import { useEffect, useState } from "react";
import { PageHeader } from "../components/PageHeader";
import { CTABand } from "../components/CTABand";
import { Reveal } from "../components/Reveal";
import { Dialog, DialogContent, DialogTitle } from "../components/ui/dialog";
import { getGallery, mediaUrl } from "../lib/api";

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => { getGallery().then(setItems).catch(() => {}); }, []);

  return (
    <div data-testid="gallery-page">
      <PageHeader
        eyebrow="Our work in pictures"
        title="Gallery"
        lead="Our teams at work across field inspections, laboratories, training rooms, and warehouses."
        crumb="Gallery"
      />
      <section className="section bg-paper">
        <div className="wrap">
          {items.length === 0 ? (
            <p className="d-lead" data-testid="gallery-empty">Photographs coming soon.</p>
          ) : (
            <div className="gallery-grid" data-testid="gallery-grid">
              {items.map((g, i) => (
                <Reveal key={g.id} delay={(i % 3) * 60}>
                  <button type="button" className="gallery-item" onClick={() => setActive(g)}
                    aria-label={`View larger: ${g.caption}`} data-testid={`gallery-item-${i}`}>
                    <img src={mediaUrl(g.media_id)} alt={g.alt || g.caption} loading="lazy" />
                    <span className="gallery-cap">{g.caption}</span>
                  </button>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="gallery-lightbox" data-testid="gallery-lightbox">
          {active && (
            <>
              <img src={mediaUrl(active.media_id)} alt={active.alt || active.caption} />
              <DialogTitle style={{ fontFamily: "'IBM Plex Mono'", fontSize: ".78rem", letterSpacing: ".12em", textTransform: "uppercase", color: "var(--muted)", fontWeight: 500 }}>
                {active.caption}
              </DialogTitle>
            </>
          )}
        </DialogContent>
      </Dialog>

      <CTABand />
    </div>
  );
}
